export * as rewardsSpi from '@wix/auto_sdk_loyalty_rewards-spi';
export * as pointsAdjustmentSpi from '@wix/auto_sdk_loyalty_points-adjustment-spi';
export * as earnPointsLimitSpi from '@wix/auto_sdk_loyalty_earn-points-limit-spi';